import React from 'react';
import { CSVLink } from 'react-csv';
import { useMount } from 'react-use';

export const DashboardInsightsJourneyDownloadVisitorsCSVLink = <T extends object>({
  fileName,
  data,
  onComplete,
}: {
  fileName: string;
  data: T[];
  onComplete: () => void;
}) => {
  const linkRef = React.useRef<any>(null);

  useMount(() => {
    if (!linkRef.current) {
      return;
    }
    linkRef.current.link.click();
    onComplete();
  });

  return <CSVLink key={fileName} data={data} filename={fileName} className='hidden' ref={linkRef} />;
};
